<template>
  <div class="splashscreen">
    <div class="splashscreen-wrapper">
      <img
      class="splashscreen-logo"  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAAAkCAMAAABymBI8AAAAdVBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////li2ZAAAAAJnRSTlMA978EsaBQPzYL4scQ8epEYC8fp3y4Z5Z0W4+JShTQm29WKIMZ2C8kdgwAAAMASURBVFjD7ZbbkqMgEIYb0Xg+G0+j8ZCM7/+IK9Jgy+zsxVZt1dRW/guFRpqvG5oE3nrrrR+nTQr+Qpacensj/O8I/NbbVlnl1OZVpWX3A/9HCGvlNG2h7XWCI1auAUI0BZ2B4LtSx/S87Z1pxlmrHHjt5nmRoaXV5DTz+gWB9/Lt+CDk25sWq+FQy06bwy8IpWwlL8IZerDLkZ1MOLQFQBuo8dRA0EuGgoHfN6oZdn1cTCVFuKFxdzozgk4Q7O1AeIXER88RwdQEAE/SFz5bJGBoEVgnwoh79gToNqpBI9jHA8ZPYylEMJVDQVKe5MJLJQlS8Wq8eH/GkUbADFocRjFyKuCIgByAX2p13yBMNAmxB7xU+RhEMhoAVyDOCsE+DwJuVlmjbbkiDOZSCacIza2KkR0ex2mJJQFAhAOhmCBKkFsiaERAMXG6AowWcMy+IpQY1rO+q60iCK0oOsz/a3+HEez5ZgdBqH0c0JiW5IrwAQCFbNZFUVQyyivCEYp0OmHgJwI7nCObu/cLgZSIyHxcSTPwEqdYZom4mylfI1hLvsrWHZBWtVXySRGnYoYvVj8JaBoQASzjFGNxUr0UQg8AiOCQMxiSLIyi/ZCdlSkGSmBuREAQMCDvC0LhkHMXyfYDduXokZyFkgNkiOOHm2LgZxnhccw43lw2Imi5Krt9JOQW+4M7NPIEz90Z2ZNWxKO/qxbMGPNJwBgtylT0OhMhVBXBRNV0cZCfe9uC0KS+dAJseYhgqIIokQy+Jrh1zLiaAq4RzgqrsPV5D8Tni0aoAbNvUv8WIR71PZuQmu/Y9YJOQSGE/K7SFwVXXxk4qnGouQ6z3EQgwP2XWwdujNpa+jPloXHRVwsyjQYCqWPMEkHQfI00V6evwJOmNKE/ghQBbMw/B4/kwRrBQAA+kds5hQsC/kUJMkDlmN34IwLU2OP1Zq9wRcjPDPoVQjw6AIqAcm0mA3tGYIq7WedxYnh1VVWn1AL+0D7bZYQ/qxiybCjgO/luli0rvPXWz9Mvmj3x4dQQ1+MAAAAASUVORK5CYII=" />

      <span class="splashscreen-text">
        {{ $t('splashscreen.loadingText') }}
      </span>
    </div>
  </div>
</template>

<script>
import ErrorUtils from './../helpers/ErrorUtils.js';

export default {
  name: 'splashscreen',
  mounted () {
    this.$http.post('/panel/general/get-configuration').then(response => {
      this.$store.commit('config/setConfig', response.data);
      this.$root.defaultCurrency = response.data.default_currency;
      this.$root.renewCurrency = response.data.renew_currency;
      this.$bus.$emit('configuration-loaded');
      let nextRoute = this.$route.params.nextRoute;

      if (!nextRoute || nextRoute === '/loading') {
        nextRoute = '/';
      }

      if (typeof window.bugsnagClient !== 'undefined' && typeof this.$store.state.config.user.id === 'number') {
        window.bugsnagClient.user = {
          id: this.$store.state.config.user.id
        };
      }

      if (typeof window.ga !== 'undefined' && typeof this.$store.state.config.user.id === 'number') {
        window.ga('set', 'dimension1', this.$store.state.config.user.id);
      } else if (typeof window.ga !== 'undefined') {
        window.ga('set', 'dimension1', 0);
      }

      setTimeout(() => {
        this.$router.push(nextRoute);
      }, 1000);
    }).catch(error => {
      ErrorUtils.handleAjaxError(error, '/panel/general/get-configuration', this.$router);
      this.$router.push('/login');
    });
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.splashscreen {
  align-items: center;
  background: $color-primary;
  color: $color-light;
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000000;

  &-wrapper {
    display: block;
  }

  &-logo {
    display: block;
  }

  &-text {
    display: block;
    font-size: 1.4rem;
    margin-top: 2rem;
    padding-left: 1rem;
    position: relative;
    text-align: center;
    width: 100%;

    &:before {
      animation-name: splashscreenSpinner;
      animation-duration: 1s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      border: 4px solid $color-light;
      border-left-color: transparent;
      border-radius: 50%;
      content: "";
      display: block;
      height: 14px;
      left: -1rem;
      position: absolute;
      top: 1px;
      width: 14px;
    }
  }
}

@keyframes splashscreenSpinner {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/Splashscreen.vue